export default "__VITE_PUBLIC_ASSET__4ea98495__"